import { render, staticRenderFns } from "./RatingModePicker.vue?vue&type=template&id=65a2b34a&scoped=true"
import script from "./RatingModePicker.vue?vue&type=script&lang=js"
export * from "./RatingModePicker.vue?vue&type=script&lang=js"
import style0 from "./RatingModePicker.vue?vue&type=style&index=0&id=65a2b34a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a2b34a",
  null
  
)

export default component.exports